const worker = () => {
  // self defaults to the Window interface, which does not exist in web workers
  // We need to cast self to the Worker interface to resolve ts errors
  const selfWorker: Worker = self as any
  let intervalId: any = null

  selfWorker.onmessage = (e: MessageEvent<any>) => {
    const initialCountdown = e?.data
    if (typeof initialCountdown === 'number') {
      // Clear any existing interval to prevent multiple timers
      if (intervalId !== null) {
        clearInterval(intervalId)
      }

      let currentCountdown = initialCountdown
      intervalId = setInterval(() => {
        currentCountdown -= 1
        selfWorker.postMessage(currentCountdown)

        // Stop when we reach 0
        if (currentCountdown <= 0) {
          clearInterval(intervalId!)
          intervalId = null
        }
      }, 1000)
    }
  }
}

let code = worker.toString()
code = code.substring(code.indexOf('{') + 1, code.lastIndexOf('}'))

const createWorkerScript = () => {
  // @ts-ignore
  const blob = new Blob([code], { type: 'application/javascript' })
  // @ts-ignore
  const workerScript = URL.createObjectURL(blob)
  return workerScript
}

export default createWorkerScript
